import { fetcher } from "helpers/fetcher";

import {
  TGenerateAIJobSuggestionReq,
  TGenerateAIJobSuggestionRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const generateAIJobSuggestion = async (
  payload?: TGenerateAIJobSuggestionReq
) => {
  return await fetcher<
    TGenerateAIJobSuggestionRes,
    TGenerateAIJobSuggestionReq["data"]
  >(ENDPOINT.BU.GENERATE_AI_JOB_SUGGESTION, {
    data: payload?.data,
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.BU.GENERATE_AI_JOB_SUGGESTION.version,
      [API_HEADER.BU_ID]: payload?.idBu,
    },
  });
};

export const mutationGenerateAIJobSuggestion = async (
  payload?: TGenerateAIJobSuggestionReq
) => {
  return (await generateAIJobSuggestion(payload)).data;
};

mutationGenerateAIJobSuggestion._key = (
  payload?: TGenerateAIJobSuggestionReq,
  key?: string
) => [ENDPOINT.BU.GENERATE_AI_JOB_SUGGESTION.url, payload, key];
